import { useState } from 'react';

const faqs = [
  {
    question: 'Preciso ter experiência com tecnologia para usar a plataforma?',
    answer: 'Não! A Central da Multa foi desenvolvida para ser intuitiva e fácil de usar. Oferecemos treinamento completo, tutoriais em vídeo e suporte dedicado para ajudar você em todas as etapas.',
  },
  {
    question: 'Como funciona a IA para elaboração de recursos?',
    answer: 'Nossa inteligência artificial foi treinada com milhares de recursos deferidos e conhece toda a legislação de trânsito brasileira. Ela analisa cada infração, identifica irregularidades e sugere os melhores argumentos jurídicos.',
  },
  {
    question: 'Os editais enriquecidos são legais?',
    answer: 'Sim, totalmente. Trabalhamos apenas com dados públicos disponíveis em editais oficiais de órgãos de trânsito. O enriquecimento é feito através de bases de dados públicas e legais.',
  },
  {
    question: 'Posso usar minha própria marca nos documentos?',
    answer: 'Claro! Todos os documentos gerados pela plataforma podem ser personalizados com sua marca, logo e identidade visual. Seus clientes verão apenas sua empresa.',
  },
  {
    question: 'Qual o prazo mínimo de contrato?',
    answer: 'Não temos prazo mínimo! Você pode cancelar a qualquer momento, sem multas ou taxas. Acreditamos que você vai ficar porque nosso serviço é bom, não porque está preso a um contrato.',
  },
  {
    question: 'Como funciona o suporte?',
    answer: 'Oferecemos suporte via chat, email e WhatsApp em horário comercial. Parceiros dos planos Intermediário e Top têm acesso a suporte prioritário e atendimento por telefone.',
  },
  {
    question: 'A plataforma funciona em todo o Brasil?',
    answer: 'Sim, a Central da Multa tem cobertura nacional. Nosso sistema está integrado com DETRANs de todos os estados e órgãos municipais das principais cidades.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-12 md:py-24 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-gray-800 via-gray-900 to-gray-800"></div>
      
      {/* Animated Orbs */}
      <div className="absolute top-1/3 left-0 w-40 md:w-80 h-40 md:h-80 bg-yellow-500/5 rounded-full blur-3xl animate-blob"></div>
      <div className="absolute bottom-1/3 right-0 w-40 md:w-80 h-40 md:h-80 bg-amber-500/5 rounded-full blur-3xl animate-blob" style={{ animationDelay: '3s' }}></div>

      <div className="max-w-4xl mx-auto px-4 md:px-6 relative z-10">
        {/* Header */}
        <div className="text-center mb-8 md:mb-16">
          <span className="inline-flex items-center gap-2 px-3 md:px-4 py-1.5 md:py-2 bg-orange-500/10 rounded-full mb-4 md:mb-6 border border-orange-500/20 backdrop-blur-sm">
            <i className="ri-question-line text-orange-400 text-sm md:text-base"></i>
            <span className="text-xs md:text-sm font-semibold text-orange-400">TIRE SUAS DÚVIDAS</span>
          </span>
          <h2 className="text-2xl md:text-5xl font-bold text-white mb-2 md:mb-4">
            Perguntas Frequentes
          </h2>
          <p className="text-sm md:text-xl text-gray-400">
            Tudo que você precisa saber antes de começar
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-2 md:space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`bg-gray-800/50 backdrop-blur-xl rounded-xl md:rounded-2xl border overflow-hidden transition-all duration-500 group ${
                openIndex === index 
                  ? 'border-yellow-500/30 shadow-lg shadow-yellow-500/10' 
                  : 'border-gray-700/50 hover:border-gray-600/50'
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-4 md:px-8 py-4 md:py-6 flex items-center justify-between text-left cursor-pointer"
              >
                <span className={`text-sm md:text-lg font-semibold pr-3 md:pr-4 transition-colors duration-300 ${
                  openIndex === index ? 'text-yellow-400' : 'text-white group-hover:text-yellow-400'
                }`}>
                  {faq.question}
                </span>
                <div
                  className={`w-8 md:w-10 h-8 md:h-10 rounded-lg md:rounded-xl flex items-center justify-center flex-shrink-0 transition-all duration-500 ${
                    openIndex === index 
                      ? 'bg-gradient-to-br from-yellow-500 to-amber-500 rotate-180' 
                      : 'bg-gray-700/50 group-hover:bg-gray-700'
                  }`}
                >
                  <i className={`ri-arrow-down-s-line text-base md:text-xl ${
                    openIndex === index ? 'text-gray-900' : 'text-gray-400'
                  }`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-500 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-4 md:px-8 pb-4 md:pb-6">
                  <div className="h-px bg-gradient-to-r from-transparent via-gray-700 to-transparent mb-3 md:mb-6"></div>
                  <p className="text-xs md:text-base text-gray-400 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
